import { GetRfxClassesByGeoQuery } from 'types/generated/client';
import { formatSessionCadence } from 'utils/shared/time/formatSessionCadence';
import { getEventSchedule } from 'utils/shared/time/getEventSchedule';
import { resolveVenueTimeZone } from 'utils/shared/time/venueDayFilters';
import { ClinicType } from './props';

export type RfxClassEvent = GetRfxClassesByGeoQuery['events'][number];

/**
 * Shapes an RFX event like a group lesson so the clinics marketplace can list it.
 * The row's date is the next session, not the pack's first week, and the price is
 * the pack's (its one group), falling back to the event's registration price.
 */
export const toClinicRow = (event: RfxClassEvent, distance: number): ClinicType => {
  const { sessions, current } = getEventSchedule(event);
  const group = event.groups[0];
  const host = event.hostUserProfile;

  return {
    id: event.id,
    title: event.title,
    description: event.description,
    sport: event.sport,
    type: event.type,
    startDateTime: current.startsAt,
    endDateTime: current.endsAt,
    timezoneName: event.timezoneName,
    timezoneAbbreviation: event.timezoneAbbreviation,
    intendedAgeGroup: null,
    skillLevels: [],
    externalBookingUrl: '',
    externalSource: null,
    coverImageProviderUrl: event.coverImageProviderUrl ?? '',
    ownerProfile: host
      ? {
          id: host.id,
          fullName: host.fullName,
          profileImageUrl: host.profileImageUrl,
          username: host.username,
          isProfessionalRacquetRegistryActive: null,
          priceUnitAmountCoachDefault: null,
          stripeMerchantCurrency: null,
          currencyCoachDefault: null,
          coachReviewsAggregate: { aggregate: null },
        }
      : null,
    priceUnitAmount: group?.priceUnitAmount || event.registrationPriceUnitAmount || 0,
    currency: event.currency,
    participantLimit: event.participantLimit ?? group?.teamLimit ?? null,
    participants: event.registrations.map((registration) => ({
      id: registration.id,
      userProfile: registration.userProfile,
    })),
    userCustomCourt: null,
    venue: event.venue,
    distance,
    rfxEvent: {
      slug: event.slug,
      sessionCount: sessions.length,
      cadence: formatSessionCadence(sessions, resolveVenueTimeZone(event)),
    },
  };
};
